export default {
  title: 'Overzicht',
  table_title: 'Reserveringen',
  filters: {
    card_title: 'Filters',
    today: 'Vandaag',
    upcoming: 'Aankomend',
    past: 'Verleden',
    all: 'Alle',
    all_dates: 'Alle tijd',
    pending: 'Wachtend op bevestiging',
    canceled: 'Geannuleerd',
    removed: 'Verwijderd',
    date_label: 'Datum:',
    status_label: 'Status:',
    source_label: 'Bron:',
    source_website: 'Website',
    source_google: 'Google',
    search_label: 'Zoeken:',
    search_placeholder: 'Zoek op voor- of achternaam',
    custom_date_tooltip: 'Kies een specifieke datum',
    active_label: 'Actieve filters:',
    clear_all: 'Alles wissen',
  },
  tooltips: {
    total_reservations: 'Totaal reserveringen',
    total_guests: 'Totaal gasten',
    refresh: 'Verversen',
  },
  empty: {
    default: 'Nog geen reserveringen.',
    filtered: 'Geen reserveringen voldoen aan uw filters.',
  },
  fields: {
    company: 'Restaurant',
    datetime: 'Datum / tijd',
    customer: 'Klant',
    source: 'Bron',
    guests: 'Gasten',
    status: 'Status',
    created_at: 'Aangemaakt op',
  },
  status: {
    confirmed: 'Bevestigd',
    pending: 'Wachten op goedkeuring',
    canceled: 'Geannuleerd',
    rejected: 'Afgewezen',
    removed: 'Verwijderd',
  },
  buttons: {
    details: 'Details',
    add_reservation: 'Reservering toevoegen',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
